

function buildMatcher(pattern) {
  const regex = [new RegExp(pattern), new RegExp(pattern + `?.*`)];
  return (url) => {
    return url.match(regex[0]) || url.match(regex[1]);
  }
};

module.exports = {
    default: {
      ttl: 1000*60*60 // 30 min
    },

    matchers: [
    { urlMatches: buildMatcher(`v1/regions`) },
    { urlMatches: buildMatcher(`v1/regions/GLOBAL/countries`) },
    { urlMatches: buildMatcher(`v1/approval-types`) },
    { urlMatches: buildMatcher(`v1/unit-of-measures`) },
    { urlMatches: buildMatcher(`v1/shelf-life-units`) },
    { urlMatches: buildMatcher(`v1/restaurant-zone`) },
    { urlMatches: buildMatcher(`v1/franchise/reporting-units`) },
    { urlMatches: buildMatcher(`v1/equipment-calibration-profiles`) },
    { urlMatches: buildMatcher(`v1/phone-types`) },
    { urlMatches: buildMatcher(`v1/email-types`) },
    { urlMatches: buildMatcher(`v1/pos-types/.`) },
    { urlMatches: buildMatcher(`v1/holidays/.`) },
    { urlMatches: buildMatcher(`v1/kiosk_types`) },
    { urlMatches: buildMatcher(`v1/special-event-reasons`) }
  ],

  storage: {
    getItem: (cacheKey)=> {
      return localStorage.getItem(cacheKey);
    },
    
    setItem: (cacheKey, stringifiedValue) => {
      localStorage.setItem(cacheKey, stringifiedValue);
    },
    
    deleteItem: (cacheKey) => {
      localStorage.removeItem(cacheKey);
    }
  }
}
